import { render } from "./SinglePartnerView.vue?vue&type=template&id=363b321e"
import script from "./SinglePartnerView.vue?vue&type=script&lang=js"
export * from "./SinglePartnerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__